import { useRef } from 'react';

import Button, { ButtonProps } from 'components/Button/Button';

interface UploadFileButtonProps {
  className?: string;
  buttonText?: string;
  accept?: string;
  onFileSelect?: (files: File[] | null) => void;
  buttonProps?: ButtonProps;
}

const DEFAULT_BUTTON_TEXT = 'Upload';

export function UploadFileButton({
  className,
  accept = 'image/*',
  onFileSelect,
  buttonProps
}: UploadFileButtonProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const onChange = (e: any) => {
    const files = e.target.files;
    onFileSelect?.(files);
  };
  return (
    <div className={className}>
      <input
        style={{ display: 'none' }}
        type="file"
        onChange={onChange}
        ref={fileInputRef}
        accept={accept}
      />
      <Button
        {...buttonProps}
        isUploadButton
        onClick={() => fileInputRef.current?.click()}
      >
        {buttonProps?.children || DEFAULT_BUTTON_TEXT}
      </Button>
    </div>
  );
}
